import React from "react"
import {Box, Button, Stack, Typography, useTheme} from "@mui/joy";
import {BellDot, BookOpenCheck, ClipboardCheckIcon} from "lucide-react";
import {Link} from "react-router-dom";
import {appRoute} from "../utils/routes";
import OnlineTestIllustration from "./Illustrations/OnlineTestIllustration";
import {useTranslation} from "react-i18next"


const EmptyDashboardComponent = () => {
    const {t}=useTranslation()

    return <Stack width={"100%"} paddingBottom={4}>
        <OnlineTestIllustration />

        <Stack gap={1} alignItems={"center"}>
            <Typography level={"h2"}>
                {t("emptyDashboardTitle")}
            </Typography>
            <Typography fontWeight={"normal"}>
                {t("emptyDashboardDescription")}
            </Typography>
            <Button size={"lg"} component={Link} to={appRoute("practice")}>
                {t("emptyDashboardActionLabel")}
            </Button>
        </Stack>

    </Stack>
}

export default EmptyDashboardComponent